/* ================================================================ */
// LOADING OVERLAY COMPONENT | Loading.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import hexToRgba from 'hex-to-rgba';
// MaterialUI Components
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
//import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';
// MaterialUI Style
import useTheme from '@material-ui/styles/useTheme';
import makeStyles from '@material-ui/styles/makeStyles';
// MaterialUI Icons
import CloseIcon from '@material-ui/icons/Close';
// Assets
import {MyGlobeLoading} from '../assets/svgs';
import {getLoadingStatusV2} from '../selectors/Data';
import {getMapLoadingStatus} from '../selectors/Map';


//import lottie from 'lottie-web';
//const animationData = {"v":"5.6.6","fr":30,"ip":0,"op":150,"w":190,"h":170,"nm":"myGlobeLoader","ddd":0,"assets":[],"fonts":{"list":[{"fName":"OpenSans-Bold","fFamily":"Open Sans","fStyle":"Bold","ascent":75.9994506835938}]},"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"eyes","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":44,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.271],"y":[0]},"t":54,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":94,"s":[100]},{"t":104,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[88.748,88.005,0],"ix":2},"a":{"a":0,"k":[92.748,102.505,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":63,"s":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":71.5,"s":[100,30,100]},{"t":80,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.003921568627,0.160784313725,0.258823529412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.886,102.505],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[18,18],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.003921568627,0.160784313725,0.258823529412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[67.61,102.505],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":150,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":5,"nm":".....................................................................................................................................................................................................................................................................................................................................................................................................","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[96,93,0],"ix":2},"a":{"a":0,"k":[295.497,-0.77,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[0,0],[38.016,0],[0,-38.016],[-38.016,0],[0,38.016],[0,0],[0,0]],"o":[[0,-38.016],[-38.016,0],[0,38.016],[38.016,0],[0,0],[0,0],[0,0]],"v":[[354.932,2.19],[286.097,-66.645],[217.262,2.19],[286.097,71.025],[354.932,2.19],[354.932,-50.258],[373.738,-69.065]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"t":{"d":{"k":[{"s":{"s":159.300003051758,"f":"OpenSans-Bold","t":".....................................................................................................................................................................................................................................................................................................................................................................................................","j":0,"tr":-277,"lh":191.160003662109,"ls":0,"fc":[0.004,0.161,0.259]},"t":0}]},"p":{"m":0,"f":{"a":0,"k":-18.448,"ix":5},"l":{"a":0,"k":0,"ix":6},"a":0,"p":0,"r":0},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[{"nm":"Animator 1","s":{"t":0,"xe":{"a":0,"k":0,"ix":7},"ne":{"a":0,"k":0,"ix":8},"a":{"a":0,"k":100,"ix":4},"b":1,"rn":0,"sh":3,"s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":2,"s":[100]},{"i":{"x":[0.665],"y":[1]},"o":{"x":[0.331],"y":[0]},"t":60,"s":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.334],"y":[0]},"t":84,"s":[2.6]},{"t":143,"s":[100]}],"ix":1},"r":1},"a":{"o":{"a":0,"k":0,"ix":9}}}]},"ip":0,"op":150,"st":0,"bm":0}],"markers":[],"chars":[{"ch":".","size":159.300003051758,"style":"Bold","w":28.52,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.498,-1.448],[-2.734,0],[-1.498,1.481],[0,2.572],[1.481,1.433],[2.702,0],[1.465,-1.399],[0,-2.734]],"o":[[1.497,1.448],[2.669,0],[1.497,-1.481],[0,-2.669],[-1.482,-1.432],[-2.8,0],[-1.465,1.4],[0,2.637]],"v":[[7.959,-0.854],[14.307,1.318],[20.557,-0.903],[22.803,-6.982],[20.581,-13.135],[14.307,-15.283],[7.91,-13.184],[5.713,-6.982]],"c":true},"ix":2},"nm":".","mn":"ADBE Vector Shape - Group","hd":false}],"nm":".","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"Open Sans"}]};

/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(/*theme => (*/{
    paper: {
        backgroundColor: 'rgba(35,35,45, 0.8)',//'#23232d',
        //backgroundColor: hexToRgba(theme.palette.background.paper, '0.9'),
        transition: 'all 500ms ease-in-out'
    },
    logo: {
        opacity: 1,
        width: '50%',
        height: '50%',
        objectFit: 'contain',
        pointerEvents: 'none',
        transition: 'all 500ms ease-in-out'
    },
    content: {
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        height: 'calc(100% - 5em)',
        padding: 0,
        margin: 0,
        '&:first-child': {
            padding: 0
        }
    },
    overlay: {
        height: '100%',
        display: 'flex',
        flexAlign:'center',
        justifyContent:'center',
        alignItems: 'center'
    },
    close: {
        position: 'absolute',
        right: '1em',
        top: '1em',
        color: '#FAFAFA'//theme.palette.text.primary
    },
    loadingIcon: {
        backgroundColor: 'white',
        height: '20em',
        width: '20em'
    },
    // Passive Loader
    passiveLoader: {
        position:'absolute',
        textAlign:'center',
        bottom:0,
        width:'100%',
        color: '#FAFAFA',//theme.palette.text.primary,
        zIndex: '200',
        fontSize:'.9rem',
        '& p':{
            paddingBottom:'1em',
        }
    },
    bar: {
        background:'none'
    }
});//);
/* ========================================== */
/**
 *  Loading Overlay
 *  --------------
 *  Displays a static loading overlay
 *
 *  @param {object} props component props
 *  @param {bool} props.isLoading current loading status
 *  @param {bool} props.isManual manual close
 */
/* ========================================== */
const Loading = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const loadingRef = useRef(null);
    const {
        isLoading,
        isMapLoading,
        isManual
    } = props;
    const [open, setOpen] = useState(true);
    /* ======================== */
    // EFFECTS
    /* ======================== */
    /*useEffect(()=>{
        lottie.loadAnimation({
            container: loadingRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData
        });
    }, [loadingRef]);*/
    /**
     * Automatic Closing on loaded
     */
    useEffect(() => {
        if(!isManual && !isLoading && !isMapLoading && open)
            handleClose();
    }, [isLoading, isMapLoading, open, isManual]);
    /* ======================== */
    // HANDLERS
    /* ======================== */
    /**
     * Handle Close
     * ------------
     * Sets open state of dialog box to
     * false
     */
    function handleClose() {
        setOpen(false);
    }
    /* ======================== */
    // RENDER
    /* ======================== */
    /*const Transition = React.forwardRef(function Transition(props, ref) {
        return <Fade direction="up" forwardedRef={ref} {...props} />;
    });*/
 
    return (
        <Dialog
            fullScreen
            onClick={handleClose}
            open={open}
            aria-labelledby={'Loading Overlay'}
            classes={{
                paper: classes.paper
            }}
            keepMounted={true}
            transitionDuration={{
                enter: 0,
                exit: 1500
            }}
            //TransitionComponent={Transition}
            //TransitionProps={{mountOnEnter: true, unmountOnExit: true}}
        >
            <DialogContent className={classes.content}>
                <div className={classes.overlay}>
                    {isManual && !isLoading && !isMapLoading &&
                        <IconButton /*onClick={handleClose}*/ className={classes.close} aria-label="Close">
                            <CloseIcon style={{fontSize:'1.5em'}} />
                        </IconButton>
                    }
                    {//<div className={classes.loadingIcon} ref={loadingRef} />
                    }
                    <img alt={'MyGlobe Logo'} src="/assets/myglobe-logo-light.svg" />
                </div>
            </DialogContent>
            {(!isManual || (isLoading || isMapLoading)) && <PassiveLoader classes={classes} message={(screen.width >= 600)?'Loading Data':''} />}
        </Dialog>
    );
};
Loading.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isMapLoading: PropTypes.bool.isRequired,
    isManual: PropTypes.bool
};
Loading.defaultProps = {
    isManual: false
};
/* ========================================== */
// Export
/* ========================================== */
//export default Loading;
/* ========================================== */
// Redux
/* ========================================== */
const mapStateToProps = store => {
    const getLoading = getLoadingStatusV2('globe');
    return {
        isLoading: getLoading(store),
        isMapLoading:getMapLoadingStatus(store,'map')
    };
};
/* ========================================== */
// Export
/* ========================================== */
export default connect(mapStateToProps)(Loading);//(React.memo(Layout, areEqual));


const PassiveLoader = ({classes, message}) => <div className={classes.passiveLoader}><p>{message}</p><LinearProgress className={classes.bar} color="primary" variant="query" /></div>;
PassiveLoader.propTypes = {
    classes: PropTypes.object.isRequired,
    message: PropTypes.string
};
PassiveLoader.defaultProps = {
    message: ''
};